import CustomerProfilesCard from "../../components/Admin/CustomerProfilesCard";

export default function CustomerProfiles() {
  return <CustomerProfilesCard limit={10} showPagination={true} />;
}
